<script>
import pdf from "@/assets/images/icons/pdf.png";
export default {
  name: "UploadPopover",
  props: ["option", "sourceId", "showPV", "dzId", "pvId"],
  data() {
    return {
        uploadFiles: [],
        maxFilesize: 100,
        acceptedFiles: "image/*,application/pdf",
    }
  },
  methods: {
    hidePopOver() {
        this.uploadFiles = [];
        this.$refs.input.value = '';
        this.$emit("closePopover");
    },
    async showFileChooser() {
        this.$refs.input.click();
    },
    handleFileUpload(file){
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = () => {
                resolve(reader.result);
            };
            reader.onerror = reject;
            reader.readAsDataURL(file);
        })
    },
    async setDocuments(e){
        const files = e.target.files;
        let uploadFiles = [];
        if (typeof FileReader === "function") {
            const reader = new FileReader();
            for await(const file of files){
                const result = await this.handleFileUpload(file);
                if(result){
                    uploadFiles.push({
                        src: file.type.toLowerCase().includes('pdf') ? pdf : result,
                        name: file.name,
                        size: file.size,
                        type: file.type,
                        file: file,
                        description: '',
                        error: false,
                        errorMessage: '',
                        inputError: false,
                    })
                }
            }
            this.uploadFiles = this.uploadFiles.concat(uploadFiles);
        } else {
            alert("Sorry, FileReader API not supported");
        }
    },
    removeDocument(index){
        this.uploadFiles.splice(index, 1);
    },
    async uploadToServer(data){
        try{
            let response = await this.$store.dispatch("filemanager/UploadFile", data);
            if (response.data.error) {
                return { error: true, message: response.data.errorMessage };
            }
            return { error: false, data: response.data };
        }catch(e){
            return { error: true, message: "Something went wrong" };
        }
    },
    async uploadDocument(){
        let errorDetails = [];
        for await(const file of this.uploadFiles){
            if(!file.description){
                file.inputError = true;
                errorDetails.push(file);
            }
            if(file.size > this.maxFilesize * 1024 * 1024){
                file.error = true;
                file.errorMessage = `File size should not exceed ${this.maxFilesize}mb`;
                errorDetails.push(file);
            }
            if(file.type !== 'application/pdf' && !file.type.includes('image')){
                file.error = true;
                file.errorMessage = `Only pdf and images are allowed to upload`;
                errorDetails.push(file);
            }
        }
        if(errorDetails.length) return;
        errorDetails = [];
        let successFiles = [];
        for await(const file of this.uploadFiles){
            let data = {
                id: this.sourceId,
                type: this.option.type,
                folder: this.option.folder,
                description: file.description,
                file: file.file,
            }
            let response = await this.uploadToServer(data);
            if(response.error){
                file.error = true;
                file.errorMessage = response.message;
                errorDetails.push(file);
            }else{
                successFiles.push({file: file, response: response.data});
            }
        }
        if(successFiles.length){
            successFiles.map(item => {
                let index = this.uploadFiles.indexOf(item.file);
                this.uploadFiles.splice(index, 1);
                this.$emit("uploaded", item.response);
            })
            this.showToast(`Succesfully uploaded - ${successFiles.length} files`, 'success');
        }
        if(errorDetails.length) return;
        this.hidePopOver();
    },
  }
}
</script>
<template>
    <b-popover
        :target="pvId"
        triggers="click"
        :placement="option.placement"
        custom-class="popover-documents"
        :show.sync="showPV"
    >
        <template v-slot:title>
            <div class="d-flex align-items-center justify-content-between">
                <small>Upload Documents</small>
                <span
                class="bx bx-x font-size-14 cursor-pointer"
                @click="hidePopOver"
                ></span>
            </div>
        </template>
        <div class="text-center bg-soft-grey upload-drop-div position-relative" :class="{'py-3 cursor-pointer min-height-250px': !uploadFiles.length}">
            <div class="d-flex justify-content-center flex-column align-items-center px-5 drop-message position-absolute top-0" v-if="!uploadFiles.length" @click="showFileChooser">
                <h3 style="font-size:1.421875rem;" class="text-green">
                    Drag and drop or click here to upload content
                </h3>
                <div style="color:#a6b0cf;font-size:18px;">
                    only pdf and images are allowed to upload (max 100mb)
                </div>
            </div>
            <template v-if="uploadFiles.length">
                <div style="height:8px;width:100%;" class="cursor-pointer" @click="showFileChooser"></div>
                <div class="d-flex" v-for="(x, xIndex) in uploadFiles" :key="xIndex" style="gap:10px;">
                    <div style="width:40% !important">
                        <div class="upload-drop-file-preview" >
                            <div class="upload-drop-image" :class="{'border border-danger p-2 border-r-5px': x.error}">
                                <img :src="x.src" :alt="x.name">
                            </div>
                            <!-- <div class="dz-progress"><span class="dz-upload"></span></div> -->
                        </div>
                        <div class="dz-details text-center px-2">
                            <div class="dz-filename text-ellipsis px-2" :title="x.name"><span>{{x.name}}</span></div>
                            <div class="dz-error-message px-2 border border-danger border-r-5px" v-if="x.error"><span class="text-danger" style="font-weight:600;">{{x.errorMessage}}</span></div>
                        </div>
                    </div>
                    <div style="margin-block:15px; margin-right:10px; width:60% !important">
                        <textarea class="form-control upload-textarea" :class="{'is-invalid': x.inputError && !x.description}" placeholder="Add Description" v-model="x.description"></textarea>
                        <div class="input-error" v-if="x.inputError && !x.description">
                            <span class="text-danger">This field is required</span>
                        </div>
                        <button type="button" class="cursor-pointer btn btn-sm btn-danger mt-2 btn-block" @click="removeDocument(xIndex)"><i class="bx bx-trash me-1"></i>Remove File</button>
                    </div>
                </div>
                <div style="height:8px;width:100%;" class="cursor-pointer" @click="showFileChooser"></div>
            </template>
        </div>
        <input ref="input" type="file" name="image" :accept="acceptedFiles" @change="setDocuments" multiple class="d-none"/>
        <div class="text-right mt-3">
            <button
                type="button"
                class="btn btn-success btn-sm me-1"
                @click="uploadDocument()"
                v-if="uploadFiles.length"
            >
                <i class="bx bx-upload me-1"></i>Upload
            </button>
            <button type="button" class="btn btn-sm" @click="hidePopOver">
                <i class="bx bx-x me-1"></i>Cancel
            </button>
        </div>
    </b-popover>
</template>